(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clara-compare-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCompare(root) {
      var range = root.querySelector('.cmp-range');
      if (!range) return;
      range.addEventListener('input', function () {
        root.style.setProperty('--pos', range.value + '%');
      });
    }
    function boot() { document.querySelectorAll('[data-compare]').forEach(initCompare); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clara-house-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHouseMap(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.hm-item'));
      var zones = Array.prototype.slice.call(root.querySelectorAll('.hm-zone'));
      if (!items.length || !zones.length) return;

      function select(zoneKey) {
        /* clicking the open zone closes it again — rows always collapse back */
        if (root.getAttribute('data-active') === zoneKey) zoneKey = null;
        if (zoneKey) root.setAttribute('data-active', zoneKey);
        else root.removeAttribute('data-active');
        items.forEach(function (it) {
          var on = !!zoneKey && it.getAttribute('data-zone') === zoneKey;
          it.classList.toggle('active', on);
          var btn = it.querySelector('.hm-row');
          if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        zones.forEach(function (z) {
          z.classList.toggle('active', !!zoneKey && z.getAttribute('data-zone') === zoneKey);
        });
      }

      items.forEach(function (it) {
        var btn = it.querySelector('.hm-row');
        if (btn) btn.addEventListener('click', function () { select(it.getAttribute('data-zone')); });
      });
      zones.forEach(function (z) {
        z.addEventListener('click', function () { select(z.getAttribute('data-zone')); });
        z.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(z.getAttribute('data-zone')); }
        });
      });

      // resting state: nothing expanded — the list stays compact beside the
      // house, every pipe ticking over. Rows open (and close) on click only.
    }
    function boot() { document.querySelectorAll('[data-housemap]').forEach(initHouseMap); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-big-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-target'));
      if (isNaN(target)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = Math.round(target).toLocaleString('en-AU'); return;
      }
      el.textContent = '0';
      var dur = 1600, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('en-AU');
        if (p < 1) { requestAnimationFrame(step); }
      }
      requestAnimationFrame(step);
    }
    function onVisible(el, cb) {
      var done = false;
      function fire() { if (done) return; done = true; cb(); }
      function check() {
        if (done) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) fire();
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
        }, { threshold: 0.2 });
        io.observe(el);
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
    function boot() {
      document.querySelectorAll('[data-kbig]').forEach(function (s) {
        s.querySelectorAll('.kbig-num').forEach(function (el) {
          var t = parseFloat(el.getAttribute('data-target'));
          if (!isNaN(t)) el.textContent = Math.round(t).toLocaleString('en-AU');
        });
        onVisible(s, function () { s.querySelectorAll('.kbig-num').forEach(animate); });
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-cart-extras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      var box = document.getElementById('kcx-upsell');
      var btn = document.getElementById('kcx-add');
      if (!box || !btn) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var hasWH = false, hasRO = false;
        (c.items || []).forEach(function (i) {
          if (i.handle === 'whole-house') hasWH = true;
          if (i.handle === 'under-sink-ro') hasRO = true;
        });
        box.hidden = !(hasWH && !hasRO);
      }).catch(function () { /* no-op */ });
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = 'Adding…';
        if (window.kelpieTrack) kelpieTrack('cart_upsell_added', { product: 'under-sink-ro' });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1 }] })
        }).then(function () { window.location.reload(); })
          .catch(function () { btn.disabled = false; btn.textContent = 'Add — $899'; });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-counters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-target'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      if (isNaN(target)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = target.toFixed(decimals); return;
      }
      el.textContent = (0).toFixed(decimals);
      var dur = 1400, start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) { requestAnimationFrame(step); } else { el.textContent = target.toFixed(decimals); }
      }
      requestAnimationFrame(step);
    }
    function onVisible(el, cb) {
      var done = false;
      function fire() { if (done) return; done = true; cb(); }
      function check() {
        if (done) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) fire();
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
        }, { threshold: 0.2 });
        io.observe(el);
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
    function boot() {
      document.querySelectorAll('[data-kcount]').forEach(function (s) {
        onVisible(s, function () { s.querySelectorAll('.kcount-num').forEach(animate); });
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-ghost-stat"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function onVisible(el, cb) {
      var done = false;
      function fire() { if (done) return; done = true; cb(); }
      function check() {
        if (done) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) fire();
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
        }, { threshold: 0.3 });
        io.observe(el);
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
    function boot() {
      document.querySelectorAll('[data-kghost]').forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top > window.innerHeight) {
          s.classList.add('pre');
          onVisible(s, function () { s.classList.remove('pre'); });
        }
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-phototabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      var tabs = root.querySelectorAll('[data-kpt-tab]');
      var panels = root.querySelectorAll('[data-kpt-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var n = tab.getAttribute('data-kpt-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-on', p.getAttribute('data-kpt-panel') === n);
          });
        });
      });
    }
    function boot() { document.querySelectorAll('[data-kpt]').forEach(initTabs); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
    else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-precheckout"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kpc2]');
    if (!root) return;
    var upHandle = root.getAttribute('data-upsell-handle');
    var upVariant = parseInt(root.getAttribute('data-upsell-variant') || '0', 10);
    var upCents = parseInt(root.getAttribute('data-upsell-cents') || '0', 10);
    var onceVariant = parseInt(root.getAttribute('data-upsell-once-variant') || '0', 10) || upVariant;
    var onceCents = parseInt(root.getAttribute('data-upsell-once-cents') || '0', 10) || upCents;
    var els = {
      bag: root.querySelector('[data-kpc2-bag]'),
      img: root.querySelector('[data-kpc2-img]'),
      title: root.querySelector('[data-kpc2-title]'),
      plan: root.querySelector('[data-kpc2-plan]'),
      main: root.querySelector('[data-kpc2-main]'),
      empty: root.querySelector('[data-kpc2-empty]'),
      yn: root.querySelector('[data-kpc2-yn]'),
      have: root.querySelector('[data-kpc2-have]'),
      noprice: root.querySelector('[data-kpc2-noprice]'),
      setupsub: root.querySelector('[data-kpc2-setupsub]'),
      total: root.querySelector('[data-kpc2-total]'),
      go: root.querySelector('[data-kpc2-go]')
    };
    var cartTotal = 0, choice = 'sub', hasRO = false, mainTitle = '';

    function money(cents) {
      var d = cents / 100;
      var s = d.toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: (d % 1 ? 2 : 0) });
      return '$' + s;
    }
    function sync() {
      if (els.yn) {
        els.yn.querySelectorAll('[data-kyn]').forEach(function (c) {
          var on = c.getAttribute('data-kyn') === choice;
          c.classList.toggle('is-on', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      var adding = choice !== 'no' && !hasRO;
      var total = cartTotal + (adding ? (choice === 'once' ? onceCents : upCents) : 0);
      if (els.total) els.total.textContent = money(total);
      if (els.setupsub) els.setupsub.textContent = mainTitle + ((adding || hasRO) ? ' + Under-Sink RO' : '') + ' · installed';
      if (els.go) els.go.textContent = (hasRO ? els.go.getAttribute('data-l-have') : (adding ? els.go.getAttribute('data-l-add') : els.go.getAttribute('data-l-no'))) + ' · ' + money(total);
    }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.item_count) {
        if (els.empty) els.empty.hidden = false;
        return;
      }
      cartTotal = cart.total_price;
      var main = cart.items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; })[0];
      hasRO = cart.items.some(function (i) { return i.handle === upHandle; });
      mainTitle = (main.product_title || '').replace(/^The\s+Kelpie\s+/i, '');
      if (els.img && main.image) { els.img.src = main.image; }
      if (els.title) els.title.textContent = main.product_title + ' · ' + money(main.final_line_price);
      if (els.plan) {
        var bits = [];
        if (/subscribe/i.test(main.variant_title || '')) bits.push('Subscribe & Save');
        var props = main.properties || {};
        for (var k in props) { if (props[k]) bits.push(k + ': ' + props[k]); }
        els.plan.textContent = bits.join(' · ');
      }
      if (hasRO && els.yn) { els.yn.hidden = true; if (els.have) els.have.hidden = false; }
      if (els.noprice) els.noprice.textContent = money(cartTotal);
      if (els.bag) els.bag.hidden = false;
      if (els.main) els.main.hidden = false;
      sync();
      if (window.kelpieTrack) kelpieTrack('precheckout_viewed', { has_upsell: !hasRO });
    }).catch(function () {
      window.location.href = '/cart';
    });
    if (els.yn) {
      els.yn.querySelectorAll('[data-kyn]').forEach(function (c) {
        c.addEventListener('click', function () {
          choice = c.getAttribute('data-kyn');
          if (window.kelpieTrack) kelpieTrack('precheckout_choice', { plan: choice });
          sync();
        });
      });
    }
    if (els.go) {
      els.go.addEventListener('click', function () {
        els.go.disabled = true;
        var adding = choice !== 'no' && !hasRO;
        if (window.kelpieTrack) kelpieTrack('precheckout_checkout', { plan: adding ? choice : 'none' });
        if (adding && upVariant) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: choice === 'once' ? onceVariant : upVariant, quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          }).catch(function () { els.go.disabled = false; window.location.href = '/cart'; });
        } else {
          window.location.href = '/checkout';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kelpie-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      document.querySelectorAll('[data-ktabs]').forEach(function (root) {
        var tabs = root.querySelectorAll('[data-ktab]');
        var panels = root.querySelectorAll('[data-kpanel]');
        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var i = tab.getAttribute('data-ktab');
            tabs.forEach(function (t) { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
            panels.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-kpanel') === i); });
          });
        });
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
